<mat-toolbar class="mat-elevation-z8">
  {{ 'ADDITIONAL_SERVICE_PLANNING.UNPLANNED_TASKS' | transloco }}
</mat-toolbar>

<mat-dialog-content>
  <div class="container">
    @if (data.unplannedTasks && data.unplannedTasks.length > 0) {
      <div>
        <div class="tasks-grid">
          @for (task of data.unplannedTasks; track task) {
            <div class="task-card" (click)="editTask(task)">
              <div class="task-card-header">
                <div class="vehicle-info">
                  <mat-icon class="me-2">directions_car</mat-icon>
                  <strong class="reg-no">{{task.regNo || 'No Reg'}}</strong>
                </div>
                <div class="status-badge" [ngClass]="getStatusClass(task.status)">
                  {{task.status || 'N/A'}}
                </div>
              </div>
              <div class="task-card-body">
                <div class="info-row">
                  <span class="info-label">{{ 'ADDITIONAL_SERVICE_PLANNING.ORDER' | transloco }}:</span>
                  <span class="info-value">#{{task.orderNr}}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">{{ 'ADDITIONAL_SERVICE_PLANNING.SERVICE' | transloco }}:</span>
                  <span class="info-value">{{task.name | translateAttribute}}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">{{ 'ADDITIONAL_SERVICE_PLANNING.PARKING' | transloco }}:</span>
                  <span class="info-value">
                    {{task.parkingName || 'No Parking'}}
                    @if (task.parkingSite) {
                      <span> - {{task.parkingSite}}</span>
                    }
                  </span>
                </div>
                @if (task.comment) {
                  <div class="info-row">
                    <span class="info-label">{{ 'ADDITIONAL_SERVICE_PLANNING.COMMENT' | transloco }}:</span>
                    <span class="info-value">{{task.comment}}</span>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="no-tasks-container">
        <p>{{ 'ADDITIONAL_SERVICE_PLANNING.NO_UNPLANNED_TASKS_AVAILABLE' | transloco }}</p>
      </div>
    }

  </div>
</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button mat-dialog-close>{{ 'FORM.TERMSDIALOGCLOSE' | transloco }}</button>
</mat-dialog-actions>